// Generated from legacy db.ts to keep files under 500 lines.
import { sql } from "../../base";
import type { Document } from "../../types";

const documentsModule = {
  async findByUserId(userId: string): Promise<Document[]> {
    const result = await sql`
      SELECT * FROM documents
      WHERE user_id = ${userId}
      ORDER BY upload_date DESC
    `;
    return (result || []) as Document[];
  },

  async findById(id: string, userId: string): Promise<Document | null> {
    const result = await sql`
      SELECT * FROM documents
      WHERE id = ${id} AND user_id = ${userId}
      LIMIT 1
    `;
    return result[0] as Document || null;
  },

  async create(data: Omit<Document, 'id' | 'created_at' | 'updated_at' | 'upload_date'>): Promise<Document> {
    const result = await sql`
      INSERT INTO documents (
        user_id, filename, original_filename, mime_type, size_bytes, 
        blob_url, description, metadata, status, suggested_filename
      )
      VALUES (
        ${data.user_id}, ${data.filename}, ${data.original_filename}, 
        ${data.mime_type}, ${data.size_bytes}, ${data.blob_url}, 
        ${data.description}, ${data.metadata || {}}, ${data.status || 'unfiled'},
        ${data.suggested_filename}
      )
      RETURNING *
    `;
    return result[0] as Document;
  },

  async update(id: string, userId: string, data: Partial<Document>): Promise<Document> {
    const result = await sql`
      UPDATE documents
      SET 
        filename = CASE WHEN ${data.filename === undefined} THEN filename ELSE ${data.filename} END,
        description = CASE WHEN ${data.description === undefined} THEN description ELSE ${data.description} END,
        metadata = CASE WHEN ${data.metadata === undefined} THEN metadata ELSE ${data.metadata} END,
        status = CASE WHEN ${data.status === undefined} THEN status ELSE ${data.status} END,
        processed_at = CASE WHEN ${data.processed_at === undefined} THEN processed_at ELSE ${data.processed_at} END,
        processing_notes = CASE WHEN ${data.processing_notes === undefined} THEN processing_notes ELSE ${data.processing_notes} END,
        updated_at = NOW()
      WHERE id = ${id} AND user_id = ${userId}
      RETURNING *
    `;
    return result[0] as Document;
  },

  async delete(id: string, userId: string): Promise<boolean> {
    const result = await sql`
      DELETE FROM documents
      WHERE id = ${id} AND user_id = ${userId}
    `;
    return result.count === 1;
  },

  async findUnfiled(userId: string): Promise<Document[]> {
    const result = await sql`
      SELECT d.* FROM documents d
      LEFT JOIN document_associations da ON d.id = da.document_id
      WHERE d.user_id = ${userId} AND da.id IS NULL
      ORDER BY d.upload_date DESC
    `;
    return (result || []) as Document[];
  },

  async findByMatterId(matterId: string, userId: string): Promise<Document[]> {
    const result = await sql`
      SELECT d.* FROM documents d
      JOIN document_associations da ON d.id = da.document_id
      WHERE da.matter_id = ${matterId} AND d.user_id = ${userId}
      ORDER BY d.upload_date DESC
    `;
    return (result || []) as Document[];
  },

  async findByProjectId(projectId: string, userId: string): Promise<Document[]> {
    const result = await sql`
      SELECT d.* FROM documents d
      JOIN document_associations da ON d.id = da.document_id
      WHERE da.project_id = ${projectId} AND d.user_id = ${userId}
      ORDER BY d.upload_date DESC
    `;
    return (result || []) as Document[];
  }
};

export type DocumentsModule = typeof documentsModule;

export function registerDocuments(db: { documents?: DocumentsModule }) {
  db.documents = documentsModule;
}

export { documentsModule as documents };
